import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBackNavigation } from "@/hooks/useBackNavigation";
import { t } from "@lingui/macro";

export function BackButton() {
  const { isVisible, goBack } = useBackNavigation();

  if (!isVisible) return null;

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={goBack}
        className="h-7 gap-1 text-sm text-muted-foreground hover:text-foreground animate-in fade-in duration-200"
      >
        <ArrowLeft className="h-4 w-4" />
        {t({ id: "common.back", message: "Back" })}
      </Button>
      <div className="h-4 w-px bg-border mx-2" />
    </>
  );
}
